import { render, staticRenderFns } from "./WingioOrderDashboard.vue?vue&type=template&id=584e0400&scoped=true"
import script from "./WingioOrderDashboard.vue?vue&type=script&lang=js"
export * from "./WingioOrderDashboard.vue?vue&type=script&lang=js"
import style0 from "./WingioOrderDashboard.vue?vue&type=style&index=0&id=584e0400&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "584e0400",
  null
  
)

export default component.exports